<template>
<div>
	<label>{{ label }}</label>
	<div class="row">
		<div class="col-8">
			<autocomplete-category :label="null"
			                       :placeholder-label="placeholder"
			                       @update:category="setCategoryId"
			                       ref="autocompleteCategory"></autocomplete-category>
		</div>
		<div class="col-4 d-flex">
			<loader-button block
			       variant="primary"
			       @click="download"
				   class="form-group"
				   :loading="loading"
			>
				{{ $t('lists.download') }}
			</loader-button>
		</div>
	</div>

</div>
</template>

<script>
import { isNil } from 'lodash';
import AutocompleteCategory from '@/components/elements/AutocompleteCategory';

export default {
	components: {
		AutocompleteCategory,
	},
	props: {
		label: {
			type: String,
			required: true
		},

		placeholder: {
			type: String,
			required: true
		},

		loading: {
			type: Boolean,
			default: false,
		}
	},

	data() {
		return {
			categoryId: null
		}
	},

	methods: {
		download() {
			this.$emit('download', this.categoryId);
			this.reset();
		},

		setCategoryId(category) {
			if (!isNil(category)) {
				this.categoryId = category.id;
			}
		},

		reset() {
			this.categoryId = null;
			this.$refs.autocompleteCategory.removeSelection();
		}
	},

	mounted() {
		this.reset();
	}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ListsDownloadButton.vue?5f12b5a8